import type { Conversation } from '../types/agent';
import { serializeConversationLiveView } from './liveView';

export function buildConversationSettings(conv: Conversation): Record<string, unknown> {
  const liveView = serializeConversationLiveView(conv.liveView);
  return {
    ...(conv.workspaceSettings ?? {}),
    startPagePending: conv.startPagePending,
    startPageState: conv.startPageState,
    ...(conv.pinnedAt ? { pinnedAt: conv.pinnedAt } : {}),
    ...(conv.sharedGroup ? { sharedGroup: conv.sharedGroup } : {}),
    ...(liveView ? { liveView } : {}),
  };
}
